import React from 'react';
import PropTypes from 'prop-types';
import { Container, Button } from 'common/lazy';
import { Link } from 'react-router-dom';
import { Component } from 'common/helpers';
import {
  Modal,
  Layout,
  ContentfulRichText,
  ContentfulImage,
  ContentLink,
  SVGIcon as Icon,
} from 'common/components';
import { Spacer } from '../Spacer';
import { OperationHours } from 'public/components/OperationHours';

import { track } from 'utils/analytics';
import './nav.less';

export default class AttractionsNav extends Component {
  getContainerProps(element) {
    const { color, background: backgroundColor } = this.props;
    const className = this.getElementClass(element);
    return {
      className,
      style: {
        color,
        backgroundColor,
      },
    };
  }

  getTicketsHref() {
    const { ticketsHref, venue } = this.props;
    // Preserve any query parameters
    return ticketsHref || `/venue/${venue.slug}/tickets${location.search}`;
  }

  handleLinkClick = (name) => {
    return () => {
      const { venue } = this.props;
      track(`${venue.slug} - Viewed ${name}`);
    };
  };

  isOpeningSoon = () =>
    this.props.venue?.featuredFlags?.includes('Coming Soon');

  render() {
    const { venue } = this.props;
    let { alertsText } = this.props;

    const FaqUrl = venue?.content?.FaqUrl ? `/venue/${venue.slug}/faq` : null;

    const ticketInfoUrl =
      venue?.content?.ticketInfo || venue?.content?.terms
        ? `/venue/${venue.slug}/ticket-info${location.search}`
        : null;

    // Note that position: sticky gets weird inside nested elements,
    // so need to use a fragment here.
    return (
      <React.Fragment>
        <div {...this.getContainerProps('desktop')}>
          <Container>
            <Layout
              className={this.getElementClass('sticky')}
              horizontal
              center
              spread>
              <Layout.Group>
                <Layout horizontal center extra padded>
                  <Layout.Group>
                    <Link to={`/venue/${venue.slug}`}>
                      <ContentfulImage field={venue.content.logo} height={52} />
                    </Link>
                  </Layout.Group>
                  <Layout.Group>
                    {
                      <div
                        className={this.getElementClass(
                          'operation-hours-container'
                        )}>
                        <OperationHours
                          openingHours={venue?.openingHours}
                          featuredFlags={venue?.featuredFlags}
                          furtherDays={0}
                        />
                      </div>
                    }
                  </Layout.Group>
                </Layout>
              </Layout.Group>
              <Layout horizontal right center padded>
                {venue.slug !== 'big-snow' && (
                  <Layout.Group>
                    <ContentLink
                      href={`/dreamsafe#${venue.slug}`}
                      className={this.getElementClass('link')}
                      onClick={this.handleLinkClick('DreamSafe')}>
                      #DREAMSAFE
                    </ContentLink>
                  </Layout.Group>
                )}
                {FaqUrl && (
                  <Layout.Group>
                    <ContentLink
                      href={FaqUrl}
                      className={this.getElementClass('link')}
                      onClick={this.handleLinkClick('FAQ')}>
                      <Icon name="faq" size="small" />
                      FAQ
                    </ContentLink>
                  </Layout.Group>
                )}
                {venue.content.alerts && (
                  <Layout.Group>
                    <Modal
                      size="tiny"
                      trigger={
                        <div
                          className={this.getElementClass('link')}
                          onClick={this.handleLinkClick('ParkAlerts')}>
                          <Icon name="bell" size="small" /> {alertsText}
                        </div>
                      }>
                      <div className={this.getElementClass('modalContent')}>
                        <ContentfulRichText field={venue.content.alerts} />
                      </div>
                    </Modal>
                  </Layout.Group>
                )}
                {ticketInfoUrl && (
                  <Layout.Group>
                    <ContentLink
                      href={ticketInfoUrl}
                      className={this.getElementClass('link')}
                      onClick={this.handleLinkClick('ViewInfo')}>
                      <Icon name="info" size="small" />
                      VIEW INFO
                    </ContentLink>
                  </Layout.Group>
                )}
                {venue.hasTickets && (
                  <Layout.Group>
                    <Button
                      inverted
                      as={ContentLink}
                      href={this.getTicketsHref()}
                      onClick={this.handleLinkClick('BuyTickets')}>
                      <Icon name="ticketing" size="small" />
                      <span>Buy Tickets</span>
                    </Button>
                  </Layout.Group>
                )}
              </Layout>
            </Layout>
          </Container>
        </div>
        <div className={this.getElementClass('mobile')}>
          <Container>
            <Layout vertical center padded>
              <Layout.Group>
                <Link to={`/venue/${venue.slug}`}>
                  <ContentfulImage field={venue.content.logo} width={184} />
                </Link>
              </Layout.Group>
              <Layout.Group className={this.getElementClass('open-hours')}>
                <div
                  className={this.getElementClass('operation-hours-container')}>
                  <OperationHours
                    openingHours={venue?.openingHours}
                    featuredFlags={venue?.featuredFlags}
                    furtherDays={0}
                  />
                </div>
              </Layout.Group>
            </Layout>
          </Container>
        </div>
        <div className={this.getElementClass('mobile-sticky')}>
          <Container>
            <Layout center>
              <Layout center padded>
                {venue.slug !== 'big-snow' && (
                  <Layout.Group>
                    <ContentLink
                      href={`/dreamsafe#${venue.slug}`}
                      className={this.getElementClass('link')}
                      onClick={this.handleLinkClick('DreamSafe')}>
                      #DREAMSAFE
                    </ContentLink>
                  </Layout.Group>
                )}
                {FaqUrl && (
                  <Layout.Group>
                    <ContentLink
                      href={FaqUrl}
                      className={this.getElementClass('link')}
                      onClick={this.handleLinkClick('FAQ')}>
                      <div>
                        <Icon name="faq" size="small" />
                        FAQ
                      </div>
                    </ContentLink>
                  </Layout.Group>
                )}
                {venue.content.alerts && (
                  <Layout.Group>
                    <Modal
                      size="tiny"
                      trigger={
                        <div
                          className={this.getElementClass('link')}
                          onClick={this.handleLinkClick('ParkAlerts')}>
                          <Icon name="bell" size="small" />
                          {alertsText}
                        </div>
                      }>
                      <div className={this.getElementClass('modalContent')}>
                        <ContentfulRichText field={venue.content.alerts} />
                      </div>
                    </Modal>
                  </Layout.Group>
                )}
                <Layout.Group>
                  <Link
                    to={`/venue/${venue.slug}/ticket-info`}
                    className={this.getElementClass('link')}
                    onClick={this.handleLinkClick('ViewInfo')}>
                    <div>
                      <Icon name="info" size="small" />
                      INFO
                    </div>
                  </Link>
                </Layout.Group>
              </Layout>
            </Layout>
            {venue.hasTickets && (
              <React.Fragment>
                <Spacer size="xs" />
                <Button
                  inverted
                  as={ContentLink}
                  href={this.getTicketsHref()}
                  size="small"
                  fluid
                  onClick={this.handleLinkClick('BuyTickets')}>
                  <Icon name="ticketing" size="small" />
                  <span>Buy Tickets</span>
                </Button>
              </React.Fragment>
            )}
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

AttractionsNav.propTypes = {
  venue: PropTypes.object.isRequired,
  ticketsHref: PropTypes.string,
  alertsText: PropTypes.string,
};

AttractionsNav.defaultProps = {
  alertsText: 'PARK ALERTS',
};
